export const REGISTER_POST_TYPE = 'dzsvideo';